<!--
 * @Description: 页脚
-->
<template>
  <div id="footer">
    <!-- 相关信息 -->
    <div class="about">
      <div class="container-box clearfloat">
       <div class="clearfloat">
        <div class="about_left">
          <div class="logoBox">
            <img src="https://guanwang-1429605986.cos.ap-guangzhou.myqcloud.com/static/img/logo2.png" alt="" />
          </div>
          <!-- <div class="comIntr">{{ decInc }}</div> -->
          
        </div>
        <div class="about_right clearfloat">
          <!-- <div class="rightL">
            <div v-for="(item,index) in navList" :key="index">
              <p >{{ item.name }}</p>
              <ul>
                <li v-for="(itemc,indexc) in item.children" :key="indexc" @click="toPage(itemc,indexc)" :style="item.children.length>3?'width: 49%;float: left;':''">{{ itemc.name }}</li>
              </ul>
            </div>
            
          </div> -->
          <!-- rightR -->
          <div class="rightR rightRNew">
            <div v-for="(item,index) in contactList" :key="index">
              <!-- <p>{{ item.name }}</p> -->
              <ul >
                <li v-for="(itemc,indexc) in item.children" :key="indexc">{{ itemc.name }}：{{itemc.dec }}</li>
              </ul>
            </div>
            
          </div>
        </div>
       </div>

        <!-- 暂时注释 -->
        <el-divider></el-divider>
        <div class="record">
          <div>©{{ year }} </div>
          <!-- <div class="record-devider">|</div> -->
          <div class="record-number">
           云南世策软件技术有限公司.保留所有权.<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">滇ICP备2024029480号</a>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { getHospitalLs } from "@/api/dept.js";
export default {
  name: "Footer",
  data() {
    return {
      map: null,
      center: {
        lng: 100.228,
        lat: 25.5855
      },
      location: {
        lng: 100.228,
        lat: 25.5852
      }, // 指定地点的经纬度
      popupLocation: {
        lng: 100.228,
        lat: 25.5854
      },
      zoom: 18, // 地图缩放比例
      showPopup: true,
      linkList: [
        
      ],
      navList: [
        {
          name: "产品与解决方案",
          value: "solution",
          path: "/solution",
          status: "0",
          children:[
            {
              name: "智慧安全与消防",
              value: "solution",
              path: "/solution",
              children: [],
              status: "0"
            },
            {
              name: "智能协同与组织办公",
              value: "solution",
              path: "/solution",
              children: [],
              status: "0"
            },
            {
              name: "综合运营与服务调度",
              value: "solution",
              path: "/solution",
              children: [],
              status: "0"
            },
            {
              name: "教卫融合与智能管理",
              value: "solution",
              path: "/solution",
              children: [],
              status: "0"
            }
          ]
        },
      ],
      contactList: [
        {
          name: "",
          value: "",
          path: "",
          status: "0",
          children:[
            {
              name: "地址",
              dec:"云南省昆明市官渡区中海国际中心23楼",
            },
            {
              name: "电话",
              dec:"0871-63196719",
            },
            {
              name: "邮箱",
              dec:"ynscrj1@163.com",
            },
          ]
        },
      ],
      yardList: [],
      decInc:'致力于为企业和政府机构提供全方位的数字化解决方案，推动组织职能化转型',
      year: new Date().getFullYear()
    };
  },
  mounted() {
    //this.getLs();
  },
  methods: {
    // 跳转
    toPage(row,index){
      this.$router.push({ path: row.path, query: {active:index}})
    },
    // 跳转外部网站
    openWebsite(url) {
      window.open(url, "_blank");
    },
    getLs() {
      getHospitalLs({
        pageNum: 1,
        pageSize: 10,
        isMain: "",
        hospitalName: ""
      }).then(res => {
        this.yardList = res.data.records;
      });
    }
  }
};
</script>
<style scoped lang="less">
.rightRNew{
    width:100% !important;
    ul{
        display: flex !important;
        flex-wrap: wrap;
        justify-content: center; /* 默认居中对齐 */
        gap: 20px; /* 设置间距 */
        li{
            width: calc(33.3% - 20px) !important;
            margin-bottom:0 !important; 
            text-align: center !important;   
        }
    }
}
#footer {
  width: 100%;
  min-width: 1200px;
  // height: 385px;
  color: rgba(255, 255, 255, 0.90);
  overflow: hidden;
  font-size: 12px;
  .link {
    width: 100%;
    height: 60px;
    background: #f0f2f5;
    font-weight: 400;
    font-size: 14px;
    color: #909399;
    .container-box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .link-list {
        display: flex;
        align-items: center;
        .title {
          color: #1461cc;
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
        span {
          margin-right: 40px;
          display: block;
          a {
            color: #909399;
          }
        }
      }
    }
  }
  .about {
    width: 100%;
    height: calc(100% - 60px);
    background: rgba(19, 27, 38, 1);
    .container-box {
      padding: 50px 0px;
      height: 100%;
      .about_left{
        float: left;
        width: 20%;
        // margin-top: 30px;
        .logoBox{
        //   border-bottom: 1px solid rgba(255, 255, 255, 0.20);
        //   padding-bottom: 10px;
          img{
            width: 150px;
          }
        }
        .comIntr{
          padding: 20px 0;
          box-sizing: border-box;
          letter-spacing: 2px;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.90);
        }
      }
      .about_right{
        float:right;
        // width: 60%;
         width: 80%;
        .rightL,.rightR{
          float:left;
          width: 50%;
          margin-top: 10px;
          p{
            font-size: 12px;
            color: rgba(255, 255, 255, 0.60);
          }
          ul{
            display: block;
            margin-bottom: 0px;
            li{
              padding: 10px 0;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.90);
              margin-bottom: 10px;
              cursor: pointer;
            }
            
          }
        }
        .rightL li:hover{
            color: #2469f2;
            padding-left: 5px;
            transition: .5s all;
          }
        .rightR{
          float:right;
          width: 50%;
        }
      }
    }
    .record {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
        .record-devider {
          padding: 0 20px;
        }
        .record-number {
          display: flex;
          margin-left: 5px;
          img {
            display: inline-block;
            height: 14px;
            width: 14px;
            margin-right: 4px;
          }
          a{
            color: #f0f2f5;
          }
          a:hover{
            color: #2469f2;
          }
        }
    }
    .el-divider{
      background-color: rgba(255, 255, 255, 0.20);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/FooterNew.vue